import { MapPosition } from '@innovyze/inno-map';

export const shouldIgnoreDefaultPosition = (
	hasPosition: boolean,
	newPosition: MapPosition,
): boolean =>
	!hasPosition &&
	newPosition.center[0] === 0 &&
	newPosition.center[1] === 0 &&
	newPosition.zoom === 3;
